module.exports = __webpack_public_path__ + "static/img/生活_bottom.e7392906.png";